import { useMemo } from 'react';

import { CrmSearchVariables } from 'framework-listing-lib/types';
import useCrmSearchQuery from 'framework-listing-lib/hooks/useCrmSearchQuery';
import useFetcher from './useFetcher';
import { useCrmObjectType } from '../providers/CrmObjectTypeListingClientProvider';

export default function useCrmObjectTypeFetchParams(
  args: {
    includeHiddenFilter?: boolean;
  } = { includeHiddenFilter: true }
) {
  'use memo';
  const crmSearchQuery = useCrmSearchQuery(args);
  const fetcher = useFetcher();
  const { associationSpecs, fetcherKey } = useCrmObjectType();

  const value = useMemo(() => {
    const variables: CrmSearchVariables = {
      associationSpecs,
      fetcher,
      fetcherKey,
      fetchParams: crmSearchQuery,
    };

    return variables;
  }, [associationSpecs, crmSearchQuery, fetcher, fetcherKey]);

  return value;
}
